import React, { Component } from 'react'
import { Integrations } from '../../components/Integration/ListConstants'
import ACCESS from 'utils/Access'

function verifyGate(integrationId) {
  for (let i = 0; i < Integrations.length; i++) {
    if (integrationId === Integrations[i].id) {
      return !Integrations[i].requiredGates || ACCESS.hasGates(Integrations[i].requiredGates)
    }
  }
  return true
}

const AuthHOC = {
  applyGateChecker: function(WrappedComponent, integrationId) {
    return class extends Component {
      constructor(props) {
        super(props)
      }

      componentDidMount() {
        if (!verifyGate(integrationId)) {
          window.location.replace('/settings2/integrations')
        }
      }

      render() {
        return <WrappedComponent {...this.props} />
      }
    }
  },

  applyGateCheckerThroughProps: function(WrappedComponent) {
    return class extends Component {
      constructor(props) {
        super(props)
      }

      componentDidMount() {
        if (!verifyGate(this.props.params.integrationId)) {
          window.location.replace('/settings2/integrations')
        }
      }

      render() {
        return <WrappedComponent {...this.props} />
      }
    }
  },

  applyAdminChecker: function(WrappedComponent) {
    return class extends Component {
      constructor(props) {
        super(props);
      }

      componentDidMount() {
        if (!ACCESS.isAdmin()) {
          window.location.replace('/settings2/profile')
        }
      }

      render() {
        return <WrappedComponent {...this.props} />
      }
    }
  }
}

export default AuthHOC



// WEBPACK FOOTER //
// ./src/scripts/app/utils/gateChecker.js